import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { solutionFlow, solutionFlowSummary } from '@/mocks/smart-farm';

export default function SolutionFlow() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="方案总览"
          title="一套智慧农场体系，连接生产与市场"
          subtitle="智慧农场不是单一设备或单一平台，而是围绕农田、产品、供应链、渠道与数据构建的全链路数字化体系。"
        />

        {/* 桌面端横向流程 */}
        <Reveal className="mt-12 hidden lg:block">
          <div className="grid grid-cols-7 gap-0 items-start">
            {solutionFlow.map((step, idx) => (
              <div key={step.no} className="relative flex flex-col items-center text-center px-1">
                {idx < solutionFlow.length - 1 && (
                  <div className="absolute top-8 left-1/2 w-full h-px bg-accent-300">
                    <i className="ri-arrow-right-line absolute -top-[7px] left-full -translate-x-1/2 text-accent-400 text-sm"></i>
                  </div>
                )}
                <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-accent-400 text-accent-700">
                  <i className={`${step.icon} text-xl`}></i>
                </div>
                <div className="mt-3 text-xs font-semibold text-accent-600 whitespace-nowrap">{step.no}</div>
                <div className="mt-2 text-sm font-semibold text-foreground-950 leading-snug">{step.title}</div>
                <div className="mt-2 text-xs text-foreground-500 leading-relaxed">{step.desc}</div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 移动端纵向时间轴 */}
        <Reveal className="mt-12 lg:hidden">
          <div className="flex flex-col gap-6">
            {solutionFlow.map((step) => (
              <div key={step.no} className="flex gap-4">
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50 border-2 border-accent-400 text-accent-700 shrink-0">
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                  <div className="w-px flex-1 bg-accent-300 mt-2"></div>
                </div>
                <div className="pb-6">
                  <div className="text-xs font-semibold text-accent-600">{step.no}</div>
                  <div className="mt-1 text-base font-semibold text-foreground-950">{step.title}</div>
                  <div className="mt-1 text-sm text-foreground-500 leading-relaxed">{step.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-10" delay={120}>
          <div className="flex items-start gap-3 p-5 rounded-lg bg-background-50 border border-accent-200">
            <i className="ri-double-quotes-l text-accent-600 text-xl mt-0.5"></i>
            <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
              {solutionFlowSummary}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}